import { Api, IApiResponse } from './Api';
export interface ILoginData {
    userName: string;
    password: string;
}

export interface ILoginData2fa {
    email: string;
    code: string;
}

export interface IAuthenticatedUser {
    accessToken: string;
    firstName: string;
    lastName: string;
    email: string;
}

export const AuthService = {
    logOut: (cb: any) => {
        setTimeout(cb, 100);
    },
    
    logIn: async (loginData: ILoginData) => {
        let apiResponse: IApiResponse = {
            data: null,
            error: false,
        }
        try {
            const response = await Api.post("/Authenticate/login", loginData);
            apiResponse.data = response.data;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    },

    logIn2fa: async (loginData: ILoginData2fa) => {
        let apiResponse: IApiResponse = {
            data: null,
            error: false,
        }
        try {
            const response = await Api.post("/Authenticate/login2fa", loginData);
            apiResponse.data = response.data;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    },

    checkToken: async () => {
        let apiResponse: IApiResponse = {
            data: null,
            error: false
        }
        try {
            const response = await Api.post("/Authenticate/isValid", null);
            apiResponse.data = response.data;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse
    }
}